'use strict';
import './contact.js';
import {pageScroll} from './module.js';

/**
 * Ipad
 *
 * */
var _ua = window.navigator.userAgent.toLowerCase();
var _isiPad =
  _ua.indexOf('ipad') > -1 || (_ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
if (_isiPad == true) {
  document
    .querySelector('meta[name="viewport"]')
    .setAttribute('content', `width=${TABLET_WIDTH},user-scalable=no,shrink-to-fit=yes`);
  document.getElementsByTagName('body')[0].classList.add('ipad');
}

/**
 * ページ上部
 *
 * */
document.getElementById('toTop').addEventListener('click', () => {
  pageScroll();
});

/**
 * メニューを開く
 *
 * */
document.getElementById('openMenu').addEventListener('click', () => {
  document.querySelector('body').classList.toggle('menu-on');
});
document.getElementById('closeMenu').addEventListener('click', () => {
  document.querySelector('body').classList.toggle('menu-on');
});

/**
 * ページ指定部
 * */
if (document.querySelector('.js-jump')) {
  document.querySelectorAll('.js-jump').forEach((element, _index) => {
    element.addEventListener('click', (event) => {
      const $this = event.currentTarget;
      const dataID = $this.getAttribute('data-id');
      const $target = document.querySelector(`.js-jumpTarget[data-id="${dataID}"]`);
      if ($target) {
        pageScroll($target.getBoundingClientRect().top);
      }
    });
  });
}

//-----------------------------------
// パララックス効果
//----------------------------------
const thresholdBottom = (() => {
  let result;
  if (document.getElementById('threshold')) {
    result =
      document.getElementById('threshold').clientHeight +
      document.getElementById('threshold').getBoundingClientRect().top +
      window.pageYOffset;
  }
  return result;
})();

'load scroll'.split(' ').forEach((eventName) => {
  window.addEventListener(eventName, (event) => {
    // ヘッダーON
    const headerHeight =
      document.querySelector('.header').getBoundingClientRect().top + window.pageYOffset;
    if (thresholdBottom != null && thresholdBottom < headerHeight) {
      document.getElementsByTagName('body')[0].classList.add('isHeaderColor');
      document.getElementById('toTop').classList.add('on');
    } else {
      document.getElementsByTagName('body')[0].classList.remove('isHeaderColor');
      document.getElementById('toTop').classList.remove('on');
    }

    // parallax
    document.querySelectorAll('.js-parallax').forEach((element, _index) => {
      const hit = element.getBoundingClientRect().top + window.pageYOffset;
      const scroll = document.scrollingElement.scrollTop || document.body.scrollTo || 0;
      const wHeight = document.documentElement.clientHeight;
      if (scroll > hit - wHeight + wHeight / 2) {
        element.classList.add('on');
      }
    });
  });
});
